module.exports = __webpack_public_path__ + "media/our_mission/photo_4-27d43267.webp";